// Libraries
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { rem } from 'polished';

// Components
import Modal from '../../index';

// REDUX: Actions
import { modalActions } from '~/redux/actions/modal-actions';

let afterClose;

/**
 *  A Modal that warns that he/she is about to delete their account.
 *
 * @class TermsModal
 * @extends {Component}
 */
class RulesModal extends Component {
	constructor(props) {
		super(props);
		this.onClose = this.onClose.bind(this);
	}

	// Closes the window, when the user clicks on the 'cancel' button
	onClose() {
		modalActions.hideModal();
		this.props.dispatch(modalActions.hideModal());

		if (afterClose) {
			afterClose();
		}
	}

	createMarkupFromText() {
		return { __html: this.props.modalText };
	}

	render() {
		const { onClose } = this.props;

		return (
			<Modal modalTitle={`${this.props.modalTitle}`} onClose={onClose} large center>
				<div
					id="alerts-modal"
					style={{
						textAlign: 'left',
					}}
				>
					<Wrapper>
						<div dangerouslySetInnerHTML={this.createMarkupFromText()} />
					</Wrapper>
					<Footer>
						<p>{this.props.modalFooter}</p>
					</Footer>
				</div>{' '}
			</Modal>
		);
	}
}

function mapStateToProps(state) {
	return {
		modalTitle: state.modal.properties.modalTitle,
		modalText: state.modal.properties.modalText,
		modalFooter: state.modal.properties.modalFooter,
	};
}

RulesModal.defaultProps = {
	modalTitle: '',
	modalText: '',
	modalFooter: '',
};

RulesModal.propTypes = {
	modalTitle: PropTypes.string,
	modalText: PropTypes.string,
	modalFooter: PropTypes.string,
	onClose: PropTypes.func,
};

export default connect(mapStateToProps)(RulesModal);

/////////////////////////
//  Styled Components //
/////////////////////////
// Some help text
const Wrapper = styled.div`
	min-height: 50vh;
	height: auto;
	max-height: 80vh;
	overflow-y: auto;

	@media ${props => props.theme.breakpointLarge} {
		max-height: ${rem('560px')};
	}
`;

const Footer = styled.footer`
	bottom: 0;
	display: flex;
	flex-direction: row;
	margin-bottom: 0;

	.form__button {
		width: calc(50% - 0.5rem);
		margin-right: 1rem;
		margin-top: 0;
		margin-left: 0;
		margin-bottom: 0;
		&:last-of-type {
			margin-right: 0;
		}
	}
`;



// WEBPACK FOOTER //
// ./src/components/general/modal/types/rules/index.jsx